module.exports = __webpack_public_path__ + "img/s3CardIcon1.6218c1e0.png";